import axios from 'axios';
import { Config } from 'config';
import { getAccessToken } from 'lib/Helper/Auth';
import {
  InterviewReportRequest,
  InterviewQuestionsRequest,
  InterviewReportResponse,
} from 'lib/Model/InterviewReportGenerator';

export async function generateInterviewReport(
  requestData: InterviewReportRequest,
): Promise<InterviewReportResponse> {
  const formData = new FormData();
  formData.append('file', requestData.resume);

  if (requestData.geminiNotesFile) {
    formData.append('gemini_notes_file', requestData.geminiNotesFile);
  }

  if (requestData.careerMotivation) {
    formData.append('career_motivation', requestData.careerMotivation);
  }
  if (requestData.signatureAchievement) {
    formData.append('signature_achievement', requestData.signatureAchievement);
  }
  if (requestData.behaviouralAnecdote) {
    formData.append('behavioural_anecdote', requestData.behaviouralAnecdote);
  }
  if (requestData.logistics) {
    formData.append('logistics', requestData.logistics);
  }
  if (requestData.recruiterAssessment) {
    formData.append('recruiter_assessment', requestData.recruiterAssessment);
  }

  if (requestData.otherInformation) {
    formData.append('other_information', requestData.otherInformation);
  }

  if (requestData.specificFocus) {
    formData.append('specific_focus', requestData.specificFocus);
  }

  if (requestData.tone) {
    formData.append('tone', requestData.tone);
  }

  const response = await axios.post(
    `${Config.API_BASE_URL}intranet/interview_generator/report`,
    formData,
    {
      headers: {
        'access-token': getAccessToken(),
      },
    },
  );

  return response.data as InterviewReportResponse;
}

export async function generateInterviewQuestions(
  requestData: InterviewQuestionsRequest,
): Promise<InterviewReportResponse> {
  const formData = new FormData();
  formData.append('file', requestData.resume);

  if (requestData.interviewingForVacancy) {
    formData.append('interviewing_for_vacancy', 'true');
  }

  if (requestData.jobDescription) {
    formData.append('job_description', requestData.jobDescription);
  }

  if (requestData.questionStyle) {
    formData.append('question_style', requestData.questionStyle);
  }

  if (requestData.specificFocus) {
    formData.append('specific_focus', requestData.specificFocus);
  }

  const response = await axios.post(
    `${Config.API_BASE_URL}intranet/interview_generator/questions`,
    formData,
    {
      headers: {
        'access-token': getAccessToken(),
      },
    },
  );

  return response.data as InterviewReportResponse;
}
